import React, { useEffect, useRef, useState } from "react";
import Style from "./style.module.css";
import InnerLoader from "../../../component/ui/loader/inner-loader";
import DataNotFound from "../../../component/ui/loader/data-not-found";
import { useOutletContext, useParams } from "react-router";
import Tooltip from "../../../component/ui/tooltip";
import {
  Table,
  TableBody,
  TableCard,
  TableCell,
  TableHead,
  TableHeaderWrap,
  TableRow,
} from "../../../component/table/table-layout";
import { PlusIcon } from "lucide-react";
import StatusChip from "../../../component/ui/chip/status";

const ConfigPage = () => {
  const { dropdownData, isLoading } = useOutletContext(); // from layout
  const { type } = useParams(); // route param
  const [apiData, setApiData] = useState([]);
  const tableRef = useRef(null);

  // Update data whenever dropdownData or route changes
  useEffect(() => {
    setApiData(dropdownData?.[type] || []);
  }, [dropdownData, type]);

  const handleToggle = (id) => {
    setApiData((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, status: item.status === 1 ? 0 : 1 } : item
      )
    );
  };

  return (
    <div className={`${Style.mainBody}`}>
      <div className={Style.teamSpaceDashboard}>
        <div className={Style.teamSpaceDashboard_main}>
          <div className={Style.teamSpaceDashboard_body}>
            {/* HEADER */}
            <div className={Style.empDirectory_header}>
              <div className={Style.empDirectory_header_left}>
                <h1 className="text-xl font-bold pl-3 flex items-center gap-1">
                  {type.replace("_", " ").toUpperCase()}
                </h1>
              </div>
              <div className={Style.empDirectory_header_right}>
                <div className={Style.bpfl_action}>
                  <Tooltip
                    content={`Add ${type.replace("_", " ")}`}
                    position={"left center"}
                    className={`${Style.bpfl_actionBtn} ${Style.addBtn}`}
                  >
                    <div className={Style.icon}>
                      <PlusIcon size="1em" />
                    </div>
                  </Tooltip>
                </div>
              </div>
            </div>

            {/* BODY */}
            <div className={Style.empDirectory_body}>
              {isLoading ? (
                <InnerLoader />
              ) : !apiData?.length ? (
                <DataNotFound title={type.replace("_", " ")} />
              ) : (
                <TableCard ref={tableRef}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell header>
                          <TableHeaderWrap>
                            <span>ID</span>
                          </TableHeaderWrap>
                        </TableCell>
                        <TableCell header>
                          <TableHeaderWrap>
                            <span>Name</span>
                          </TableHeaderWrap>
                        </TableCell>
                        <TableCell header>
                          <TableHeaderWrap>
                            <span>Status</span>
                          </TableHeaderWrap>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {apiData.map((eachList, index) => (
                        <TableRow key={index}>
                          <TableCell>{eachList.id}</TableCell>
                          <TableCell>{eachList.value}</TableCell>
                          <TableCell>
                            {eachList?.status == "1" ? (
                              <StatusChip color="green">Active</StatusChip>
                            ) : (
                              <StatusChip color="red">In Active</StatusChip>
                            )}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableCard>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfigPage;
